import './components/PassiveListeners';
import './components/hamburger';
import {hamburger} from "./components/hamburger";
import {scrollToTop} from "./components/scrollToTop";
import {wooCartRefresh} from "@/js/global/components/wooCartRefresh";

export const global = ()=>{
	hamburger();
	scrollToTop();
	wooCartRefresh();
}


